/* eslint-disable arrow-body-style */
import * as React from "react";
import {Component} from "react";

import {observer} from "mobx-react";

import {Dropdown} from "semantic-ui-react";

import "./perimeter-type-selector.scss";

import {DropdownItemProps} from "semantic-ui-react/dist/commonjs/modules/Dropdown/DropdownItem";
import {InputOnChangeData} from "semantic-ui-react/dist/commonjs/elements/Input/Input";
import {PerimeterType} from "../../../../../stores/auftragsverwaltung-mobx";
import {Project} from "../../../../../models/project";


export interface PerimeterTypeSelectorProps {
    project?: Project | null;
    onSelect?: (type: PerimeterType) => void;
}

@observer
export class PerimeterTypeSelector extends Component<PerimeterTypeSelectorProps, any> {

    autorunDisposers: any[] = [];

    constructor(props: PerimeterTypeSelectorProps) {
        super(props);
        this.state = {
            perimeterTypeId: props.project?.typeId === 4 ? PerimeterType.Risikouebersicht : PerimeterType.Gefahrenkarte // default value is
        };

        this.handleChange = this.handleChange.bind(this);
    }

    private get isRisikouebersicht(): boolean {
        const {project} = this.props;
        return project?.typeId === 4;
    }

    componentDidMount(): void {
        const {onSelect} = this.props;
        const {perimeterTypeId} = this.state;

        if (onSelect) {
            onSelect(perimeterTypeId);
        }
    }

    componentWillUnmount(): void {
        /*
         * Avoid `Warning: Can't perform a React state update on an unmounted component. This is a no-op, but it
         * indicates a memory leak in your application. To fix, cancel all subscriptions and asynchronous tasks
         * in the componentWillUnmount method.`
         */
        this.setState({});
    }

    render(): React.ReactElement | null {
        const {project, onSelect} = this.props;
        const {perimeterTypeId} = this.state;

        if (!project) {
            return null;
        }

        let options: DropdownItemProps[] | null;
        if (this.isRisikouebersicht) {
            options = [
                { key: 1, text: "Gefahrenkarte Risikoübersicht", value: 3 },
            ];
        }
        else {
            options = [
                { key: 1, text: "Gefahrenkarte", value: 1 },
                { key: 2, text: "Gefahrenhinweiskarte", value: 2 },
            ];
        }

        return (
            <Dropdown
                name="perimeterTypeId"
                onChange={(event: React.ChangeEvent<HTMLInputElement>, data: InputOnChangeData) => {
                    if (onSelect) {
                        onSelect(Number(data.value) as PerimeterType);
                    }
                    this.handleChange(data);
                }}
                options={options}
                selection
                disabled={this.isRisikouebersicht}
                value={perimeterTypeId}
            />
        );
    }

    handleChange(data: InputOnChangeData): void {
        this.setState({[data.name]: data.value});
    };

}
